import { transformDateValue } from 'core/js/FormUtils';
export const getRmvendorquotationView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let rmvendorquotationList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Quotation","fieldValue":transformDataValue(data.quotation,"double"), "fieldType":"double"},
                            {"fieldLabel":"rmvendor Name","fieldValue":transformDataValue(data.rmvendorname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          rmvendorquotationList.push(card);
  })
  return rmvendorquotationList;
}